module.exports = __webpack_public_path__ + "img/score_6.647e2584.png";